import React, { useState,useEffect } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import form from "../../assets/dental/form.png";
import { useNavigate } from "react-router-dom";
import { useCreateDentalContactMutation } from '../../store/api/contact'
const Visa = () => {
             const [showSuccess, setShowSuccess] = useState(false);

    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        fullName: '',
        phoneNumber: '',
        address: '',
        dateOfBirth: '',
        physiciansCare: '', // Default value
        physiciansCondition: '',
        medications: '', // Default value
        medicationsList: '',
        allergies: '', // Default value
        conditions: [],
        lastDentalVisit: '',
        reasonForVisit: '',
        symptoms: [],
        dentalHistory: [],
        brushingFrequency: [],
        tobaccoUse: '', // Default value
        mouthwashUse: '', // Default value - this was missing
        dentistVisitFrequency: [],
        mainConcerns: '',
        oralHealthImprovement: ''
    });
    
    
    const [createDentalContact, { isLoading, isError, isSuccess, error }] = useCreateDentalContactMutation();


    useEffect(() => {
                    if (isSuccess) {
                        setShowSuccess(true);
                        const timer = setTimeout(() => setShowSuccess(false), 3000); 
                        return () => clearTimeout(timer);
                    }
                }, [isSuccess]);
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            const currentValues = formData[name] || [];
            if (checked) {
                setFormData(prev => ({
                    ...prev,
                    [name]: [...currentValues, value]
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    [name]: currentValues.filter(item => item !== value)
                }));
            }
        } else if (type === 'radio') {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };
    const transformFormDataForBackend = (frontendData) => {
        return {
            full_name: frontendData.fullName,
            phone_number: frontendData.phoneNumber,
            email_address: frontendData.address, // Assuming 'address' is email in your form
            date_of_birth: frontendData.dateOfBirth,
            physicians_care: frontendData.physiciansCare,
            physicians_condition: frontendData.physiciansCondition,
            medications: frontendData.medications,
            medications_list: frontendData.medicationsList,
            allergies: frontendData.allergies,
            conditions: frontendData.conditions,
            last_dental_visit: frontendData.lastDentalVisit,
            reason_for_visit: frontendData.reasonForVisit,
            symptoms: frontendData.symptoms,
            dental_history: frontendData.dentalHistory,
            brushing_frequency: frontendData.brushingFrequency,
            tobacco_use: frontendData.tobaccoUse,
            mouthwash_use: frontendData.mouthwashUse,
            dentist_visit_frequency: frontendData.dentistVisitFrequency,
            main_concerns: frontendData.mainConcerns,
            oral_health_improvement: frontendData.oralHealthImprovement,
        };
    };


    // Handle form submission with RTK Query
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Transform the form data to match backend expectations
            const backendData = transformFormDataForBackend(formData);

            console.log('Sending data to backend:', backendData);

            // Call the mutation
            const result = await createDentalContact(backendData).unwrap();

            // Handle success
            console.log('Appointment created successfully:', result);
            ;

            // Reset form after successful submission
            setFormData({
                fullName: '',
                phoneNumber: '',
                address: '',
                dateOfBirth: '',
                physiciansCare: '',
                physiciansCondition: '',
                medications: '',
                medicationsList: '',
                allergies: '',
                conditions: [],
                lastDentalVisit: '',
                reasonForVisit: '',
                symptoms: [],
                dentalHistory: [],
                brushingFrequency: [],
                tobaccoUse: '',
                mouthwashUse: '',
                dentistVisitFrequency: [],
                mainConcerns: '',
                oralHealthImprovement: ''
            });

        } catch (error) {
            // Handle error
            console.error('Failed to create appointment:', error);

            // Show appropriate error message
            if (error.data && error.data.message) {
                alert(`Error: ${error.data.message}`);
            } else if (error.data && error.data.errors) {
                // Handle validation errors
                const errorMessages = Object.values(error.data.errors).flat().join(', ');
                alert(`Validation errors: ${errorMessages}`);
            } else {
                alert('Failed to book appointment. Please try again.');
            }
        }
    };

    return (
        <section>
            <div className="py-24 px-8  ">
                <div className="min-h-screen flex items-center justify-center">
                    <div className="bg-[#FFFBF4] rounded-tr-[40px] rounded-bl-[40px] shadow-lg max-w-6xl w-full ">
                        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
                            <div className="md:flex md:flex-col md:justify-center px-4 py-4 md:px-10 md:py-0 mb-5" >
                                <div className="flex justify-start mb-12">
                                    <button
                                        type="button"
                                        onClick={() => { navigate('/dental') }}
 className="bg-[#5B656F] hover:bg-[#3a4558] text-white text-sm md:text-sm font-medium md:py-2 py-2 md:px-4 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-1 md:gap-2"                                    >
                                        <MdOutlineKeyboardBackspace className="text-base  md:text-sm" />
                                        Back
                                    </button>
                                </div>

                                <h1 className="md:text-3xl text-2xl font-bold font-[Raleway] text-gray-900 mb-2">
                                    Book Your Appointment
                                </h1>
                                <p className="text-gray-600 mb-8 font-[Rufina]">
                                    Complete the form to secure your booking.
                                </p>
                                <form className="space-y-6  font-[Raleway]" onSubmit={handleSubmit}>
                                    <div className="grid sm:grid-cols-2 gap-4">
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="fullName"
                                                value={formData.fullName}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Full Name
                                            </label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                type="tel"
                                                name="phoneNumber"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Phone Number
                                            </label>
                                        </div>
                                    </div>

                                    <div className='grid sm:grid-cols-2 gap-4'>
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="address"
                                                value={formData.address}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Email Address
                                            </label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                type="date"
                                                name="dateOfBirth"
                                                value={formData.dateOfBirth}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Date of Birth
                                            </label>
                                        </div>
                                    </div>

                                    <fieldset className="grid gap-2">
                                        <legend className=" text-gray-600 text-[10px] md:text-[12px] ">Are you currently under physician's care ?</legend>
                                        <div className="flex flex-wrap gap-4 ">
                                            <label className="flex items-center gap-2">
                                                <input
                                                    type="radio"
                                                    name="physiciansCare"
                                                    value="yes"
                                                    checked={formData.physiciansCare === 'yes'}
                                                    onChange={handleChange}
                                                    className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                                                />
                                                <span className=' text-gray-600 text-[10px] md:text-[12px] '>Yes</span>
                                            </label>
                                            <label className="flex items-center gap-2">
                                                <input
                                                    type="radio"
                                                    name="physiciansCare"
                                                    value="no"
                                                    checked={formData.physiciansCare === 'no'}
                                                    onChange={handleChange}
                                                    className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                                                />
                                                <span className=' text-gray-600 text-[10px] md:text-[12px] '>No</span>
                                            </label>
                                        </div>
                                    </fieldset>
                                    <div className="relative">
                                        <textarea
                                            name="physiciansCondition"
                                            value={formData.physiciansCondition}
                                            onChange={handleChange}
                                            rows="3"
                                            className="w-full border border-dotted rounded-lg focus:outline-none px-3 py-3 text-[10px] resize-none"
                                            style={{ borderWidth: '2px', borderColor: '#ccc', borderStyle: 'dotted' }}
                                            required
                                        />
                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                            Yes, for what condition?
                                        </label>
                                    </div>
                                    <fieldset className="grid gap-2">
                                        <legend className=" text-gray-600 text-[10px] md:text-[12px] mb-1">Are you taking any medications? </legend>
                                        <div className="flex flex-wrap gap-4 ">
                                            <label className="flex items-center gap-2">
                                                <input
                                                    type="radio"
                                                    name="medications"
                                                    value="yes"
                                                    checked={formData.medications === 'yes'}
                                                    onChange={handleChange}
                                                    className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                                                />
                                                <span className=' text-gray-600 text-[10px] md:text-[12px] '>Yes</span>
                                            </label>
                                            <label className="flex items-center gap-2">
                                                <input
                                                    type="radio"
                                                    name="medications"
                                                    value="no"
                                                    checked={formData.medications === 'no'}
                                                    onChange={handleChange}
                                                    className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                                                />
                                                <span className=' text-gray-600 text-[10px] md:text-[12px] '>No</span>
                                            </label>
                                        </div>
                                    </fieldset>
                                    <div className="relative">
                                        <textarea
                                            name="medicationsList"
                                            value={formData.medicationsList}
                                            onChange={handleChange}
                                            rows="3"
                                            className="w-full border border-dotted rounded-lg focus:outline-none px-3 py-3 text-[10px] resize-none"
                                            style={{ borderWidth: '2px', borderColor: '#ccc', borderStyle: 'dotted' }}
                                            required
                                        />
                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                            List
                                        </label>
                                    </div>
                                    <fieldset className="grid gap-2">
                                        <legend className=" text-gray-600 text-[10px] md:text-[12px] mb-1 ">Do you have any allergies (medications, latex, etc.)? </legend>
                                        <div className="flex flex-wrap gap-4 ">
                                            <label className="flex items-center gap-2">
                                                <input
                                                    type="radio"
                                                    name="allergies"
                                                    value="yes"
                                                    checked={formData.allergies === 'yes'}
                                                    onChange={handleChange}
                                                    className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                                                />
                                                <span className=' text-gray-600 text-[10px] md:text-[12px] '>Yes</span>
                                            </label>
                                            <label className="flex items-center gap-2">
                                                <input
                                                    type="radio"
                                                    name="allergies"
                                                    value="no"
                                                    checked={formData.allergies === 'no'}
                                                    onChange={handleChange}
                                                    className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                                                />
                                                <span className=' text-gray-600 text-[10px] md:text-[12px] '>No</span>
                                            </label>
                                        </div>
                                    </fieldset>
                                    <fieldset className="grid gap-2">
                                        <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">Do you have (or have you had) any of the following?</legend>
                                        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 py-2">
                                            {[
                                                { value: "asthma", label: "Asthma" },
                                                { value: "diabetes", label: "Diabetes" },
                                                { value: "high_blood_pressure", label: "High blood pressure" },
                                                { value: "heart_disease", label: "Heart disease" },
                                                { value: "kidney_disease", label: "Kidney disease" },
                                                { value: "liver_disease", label: "Liver disease" },
                                                { value: "bleeding_disorders", label: "Bleeding disorders" },
                                                { value: "thyroid_issues", label: "Thyroid issues" },
                                                { value: "anxiety_depression", label: "Anxiety/Depression" },
                                            ].map((condition) => (
                                                <label key={condition.value} className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        name="conditions"
                                                        value={condition.value}
                                                        checked={formData.conditions.includes(condition.value)}
                                                        onChange={handleChange}
                                                        className="h-4 w-4 accent-primary"
                                                        disabled={isLoading}
                                                    />
                                                    <span className="text-gray-600 text-[10px] md:text-[12px]">{condition.label}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </fieldset>
                                    <div className="grid sm:grid-cols-2 gap-4">
                                        <div className="relative">
                                            <input
                                                type="date"
                                                name="lastDentalVisit"
                                                value={formData.lastDentalVisit}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Date of last dental visit
                                            </label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                type="text"
                                                name="reasonForVisit"
                                                value={formData.reasonForVisit}
                                                onChange={handleChange}
                                                className="w-full border border-gray-300 rounded-lg focus:border-gray-600 focus:outline-none px-3 py-3 text-[10px]"
                                                required
                                            />
                                            <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                                Reason for visit
                                            </label>
                                        </div>
                                    </div>
                                    <fieldset className="grid gap-2">
                                        <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">Do you experience any of the following?</legend>
                                        <div className="grid grid-cols-2 md:grid-cols-2 gap-2 py-2">
                                            {[
                                                { value: "tooth_sensitivity", label: "Tooth sensitivity (hot/cold/sweets)" },
                                                { value: "jaw_pain", label: "Jaw pain or clicking" },
                                                { value: "bleeding_gums", label: "Bleeding gums" },
                                                { value: "bad_breath", label: "Bad breath/dry mouth" },
                                                { value: "teeth_grinding", label: "Grinding or clenching teeth" },
                                            ].map((symptom) => (
                                                <label key={symptom.value} className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        name="symptoms"
                                                        value={symptom.value}
                                                        checked={formData.symptoms.includes(symptom.value)}
                                                        onChange={handleChange}
                                                        className="h-4 w-4 accent-primary"
                                                        disabled={isLoading}
                                                    />
                                                    <span className="text-gray-600 text-[10px] md:text-[12px]">{symptom.label}</span>
                                                </label>
                                            ))}

                                        </div>
                                    </fieldset>
                                    <fieldset className="grid gap-2">
                                        <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">Have you ever had :</legend>
                                        <div className="grid grid-cols-2 md:grid-cols-2 gap-2 py-2">
                                            {[
                                                { value: "orthodontic_treatment", label: "Orthodontic treatment (braces)" },
                                                { value: "tooth_extractions", label: "Tooth extractions" },
                                                { value: "root_canal", label: "Root canal treatment" },
                                                { value: "gum_disease", label: "Gum disease treatment" },
                                            ].map((history) => (
                                                <label key={history.value} className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        name="dentalHistory"
                                                        value={history.value}
                                                        checked={formData.dentalHistory.includes(history.value)}
                                                        onChange={handleChange}
                                                        className="h-4 w-4 accent-primary"
                                                        disabled={isLoading}
                                                    />
                                                    <span className="text-gray-600 text-[10px] md:text-[12px]">{history.label}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </fieldset>
                                    <fieldset className="grid gap-2">
                                        <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">How often do you brush your teeth?</legend>
                                        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 py-2">
                                            {[
                                                { value: "once_daily", label: "Once daily" },
                                                { value: "twice_daily", label: "Twice daily" },
                                                { value: "after_every_meal", label: "After every meal" },
                                            ].map((frequency) => (
                                                <label key={frequency.value} className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        name="brushingFrequency"
                                                        value={frequency.value}
                                                        checked={formData.brushingFrequency.includes(frequency.value)}
                                                        onChange={handleChange}
                                                        className="h-4 w-4 accent-primary"
                                                        disabled={isLoading}
                                                    />
                                                    <span className="text-gray-600 text-[10px] md:text-[12px]">{frequency.label}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </fieldset>

                                    <div className="grid grid-cols-1 md:grid-cols-2">
                                        <fieldset className="grid gap-2">
                                            <legend className=" text-gray-600 text-[10px] md:text-[12px] ">Do you use tobacco or vape?</legend>
                                            <div className="flex flex-wrap gap-4 ">
                                                <label className="flex items-center gap-2">
                                                    <input
                                                        type="radio"
                                                        name="tobaccoUse"
                                                        value="yes"
                                                        checked={formData.tobaccoUse === 'yes'}
                                                        onChange={handleChange}
                                                        className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                                                    />
                                                    <span className=' text-gray-600 text-[10px] md:text-[12px] '>Yes</span>
                                                </label>
                                                <label className="flex items-center gap-2">
                                                    <input
                                                        type="radio"
                                                        name="tobaccoUse"
                                                        value="no"
                                                        checked={formData.tobaccoUse === 'no'}
                                                        onChange={handleChange}
                                                        className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                                                    />
                                                    <span className=' text-gray-600 text-[10px] md:text-[12px] '>No</span>
                                                </label>
                                            </div>
                                        </fieldset>
                                        <fieldset className="grid gap-2">
                                            <legend className=" text-gray-600 text-[10px] md:text-[12px] ">Do you use mouthwash?</legend>
                                            <div className="flex flex-wrap gap-4 ">
                                                <label className="flex items-center gap-2">
                                                    <input
                                                        type="radio"
                                                        name="mouthwashUse"
                                                        value="yes"
                                                        checked={formData.mouthwashUse === 'yes'}
                                                        onChange={handleChange}
                                                        className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                                                    />
                                                    <span className=' text-gray-600 text-[10px] md:text-[12px] '>Yes</span>
                                                </label>
                                                <label className="flex items-center gap-2">
                                                    <input
                                                        type="radio"
                                                        name="mouthwashUse"
                                                        value="no"
                                                        checked={formData.mouthwashUse === 'no'}
                                                        onChange={handleChange}
                                                        className="md:h-4 md:w-4 h-3 w-3 accent-primary"
                                                    />
                                                    <span className=' text-gray-600 text-[10px] md:text-[12px] '>No</span>
                                                </label>
                                            </div>
                                        </fieldset>

                                    </div>
                                    <fieldset className="grid gap-2">
                                        <legend className="text-gray-600 text-[10px] md:text-[12px] mb-1">How often do you visit the dentist ?</legend>
                                        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 py-2">
                                            {[
                                                { value: "every_6_months", label: "Every 6 months" },
                                                { value: "once_a_year", label: "Once a year" },
                                                { value: "only_when_needed", label: "Only when needed" },
                                            ].map((frequency) => (
                                                <label key={frequency.value} className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        name="dentistVisitFrequency"
                                                        value={frequency.value}
                                                        checked={formData.dentistVisitFrequency.includes(frequency.value)}
                                                        onChange={handleChange}
                                                        className="h-4 w-4 accent-primary"
                                                        disabled={isLoading}
                                                    />
                                                    <span className="text-gray-600 text-[10px] md:text-[12px]">{frequency.label}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </fieldset>
                                    <div className="relative">
                                        <textarea
                                            name="mainConcerns"
                                            value={formData.mainConcerns}
                                            onChange={handleChange}
                                            rows="3"
                                            className="w-full border border-dotted rounded-lg focus:outline-none px-3 py-3 text-[10px] resize-none"
                                            style={{ borderWidth: '2px', borderColor: '#ccc', borderStyle: 'dotted' }}
                                            required
                                        />
                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                            What are your main concerns about your teeth or smile?
                                        </label>
                                    </div>

                                    <div className="relative">
                                        <textarea
                                            name="oralHealthImprovement"
                                            value={formData.oralHealthImprovement}
                                            onChange={handleChange}
                                            rows="3"
                                            className="w-full border border-dotted rounded-lg focus:outline-none px-3 py-3 text-[10px] resize-none"
                                            style={{ borderWidth: '2px', borderColor: '#ccc', borderStyle: 'dotted' }}
                                            required
                                        />
                                        <label className="absolute left-3 -top-2 text-xs text-gray-600 bg-white px-1">
                                            What would you like to improve about your oral health?
                                        </label>
                                    </div>
                                     {showSuccess && (
                                        <div className="mb-4 p-3 bg-green-100 text-green-700 text-center rounded-lg">
                                            Form submitted successfully!
                                        </div>
                                    )}

                                    <button
                                        type="submit"
                                        className="w-full bg-[#5B656F] hover:bg-[#3a4558] text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                    >
                                        Submit Application
                                        <FiArrowUpRight className="text-xl" />
                                    </button>
                                </form>
                            </div>
                            <div className="hidden lg:flex items-center justify-center">
                                <div className="relative w-full h-full min-h-[400px]">
                                    <img
                                        src={form}
                                        alt="Travel form"
                                        className="w-full h-full object-cover rounded-tr-[40px]"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Visa;
